import './style.scss';
import { InputHTMLAttributes, useState } from 'react';
import { IconSize, SvgIcon } from '../svgIcon';
import { icons } from 'constants/icons';

export type PasswordInputProps = InputHTMLAttributes<HTMLInputElement>;

export const PasswordInput = (props: PasswordInputProps) => {
  const [isRevealPassword, setRevealPassword] = useState<boolean>(false);
  const icon = isRevealPassword ? icons.eyeOn : icons.eyeOff;

  return (
    <div className={'passwordInput'}>
      <input {...props} className={'passwordInput_value'} type={isRevealPassword ? 'text' : 'password'} />

      <span onClick={() => setRevealPassword(!isRevealPassword)} className="passwordInput_action">
        <SvgIcon icon={icon} size={IconSize.icon_m} />
      </span>
    </div>
  );
};
